import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { ApiSuccess, IdentityChangeContract } from '@alamo/types';

import { apiClient } from '../client';

export interface OwnCorrectionContract {
  requiresSignature: boolean;
  canInitiate: boolean;
  contract: IdentityChangeContract | null;
}

const correctionContractKey = ['profile', 'consultant-contract'] as const;

export function useOwnCorrectionContract(enabled = true) {
  return useQuery({
    queryKey: correctionContractKey,
    enabled,
    queryFn: async () =>
      (await apiClient.get<ApiSuccess<OwnCorrectionContract>>('/profile/consultant-contract')).data
        .data,
    refetchInterval: (query) => (query.state.data?.requiresSignature ? 5000 : 30000),
  });
}

export function useInitiateCorrectionContract() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: async () =>
      (
        await apiClient.post<ApiSuccess<IdentityChangeContract>>(
          '/profile/consultant-contract/initiate',
        )
      ).data.data,
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: correctionContractKey });
    },
  });
}
